import { Link, useLocation } from "@/lib/router-compat";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <SEOHead
        title="Page introuvable - JIIA Studio"
        description="La page que vous recherchez n'existe pas ou a été déplacée."
        noindex
      />
      <section className="py-32 text-center">
        <h1 className="font-heading text-5xl mb-4">404</h1>
        <p className="text-lg text-muted-foreground font-body mb-8">Cette page n'existe pas.</p>
        <Link to="/" className="text-sm font-body uppercase tracking-widest text-accent hover:underline">
          Retour à l'accueil
        </Link>
      </section>
    </Layout>
  );
};

export default NotFound;
